import React, { useEffect, useLayoutEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheck } from 'react-icons/fa6';

import * as S from './styles';
import SimpleInput from 'components/SimpleInput';
import { UseTranslationProps } from 'types/UseTranslationProps';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import { CredentialFather } from 'types/ProvidersProps';
import { InptuSelectFeaturesSettingsProps } from 'types/InptuSelectFeaturesSettingsProps';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { returnLabelBySlug } from './functions';
import {
	saveOnBackFeatureSelected,
	saveGeneralConfig,
	getFeaturesSettings,
	getGeneralConfig
} from './reqs';

interface FeatureSettingsProps {
	isVisiable: boolean;
	listProviders: CredentialFather[];
	// setListProviders: React.Dispatch<React.SetStateAction<CredentialFather[]>>;
}

export default function FeatureSettings({
	isVisiable,
	listProviders
}: FeatureSettingsProps) {
	const { t }: UseTranslationProps = useTranslation();
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const [ruleSendText, setRuleSendText] = useState('');
	const [discountCupon, setDiscountCupon] = useState('');
	const [listInputs, setListInputs] = useState<
		InptuSelectFeaturesSettingsProps[]
	>([]);
	const [listOptionsSelect, setListOptionsSelect] = useState<
		SelectInputItemProps[]
	>([]);

	async function handleSave(
		item: InptuSelectFeaturesSettingsProps,
		idOption: string | number
	) {
		const { isSuccess, data } = await saveOnBackFeatureSelected(
			item,
			idOption,
			handleNotify,
			setIsOpenLoad,
			setMessage
		);

		if (isSuccess && data !== null) {
			// Atualiza a lista de inputs
			const newList = listInputs.map((itemInput) => {
				if (itemInput.id === data.id) {
					return data;
				}
				return itemInput;
			});

			setListInputs(newList);
		}
	}

	async function handleSaveGeneralConfig(
		value: string,
		typeConfig: 'discount_coupon' | 'free_shipping_value'
	) {
		const { data, isSuccess } = await saveGeneralConfig(
			value,
			typeConfig,
			handleNotify,
			setIsOpenLoad,
			setMessage
		);

		if (isSuccess) {
			if (typeConfig === 'discount_coupon') {
				setDiscountCupon(data?.discount_coupon || '');
			} else {
				setRuleSendText(data?.free_shipping_value?.toString() || '');
			}
		} else {
			if (typeConfig === 'discount_coupon') {
				setDiscountCupon('');
			} else {
				setRuleSendText('');
			}
		}
	}

	useLayoutEffect(() => {
		if (listProviders.length > 0) {
			const optionsSelectCopy = structuredClone(listProviders);
			const newLit: SelectInputItemProps[] = optionsSelectCopy.map(
				(item: CredentialFather) => {
					return { id: item.id, option: item.name };
				}
			);

			setListOptionsSelect(newLit);
		}
	}, [listProviders]);

	useEffect(() => {
		(async () => {
			const {
				data: dataGetFeaturesSettings,
				isSuccess: isSuccessGetFeaturesSettings
			} = await getFeaturesSettings(handleNotify, setIsOpenLoad, setMessage);

			if (isSuccessGetFeaturesSettings) {
				setListInputs(dataGetFeaturesSettings);
			}

			const {
				data: dataGetGeneralConfig,
				isSuccess: isSuccessGetGeneralConfig
			} = await getGeneralConfig(handleNotify, setIsOpenLoad, setMessage);

			if (isSuccessGetGeneralConfig) {
				setRuleSendText(
					dataGetGeneralConfig?.free_shipping_value?.toString() || ''
				);
				setDiscountCupon(dataGetGeneralConfig?.discount_coupon || '');
			}
		})();
	}, []);

	return (
		<S.container $isShow={isVisiable}>
			<S.threeItensPorLine>
				<SimpleInput
					label={t('settings.featureSettings.ruleToSend')}
					initialValue={ruleSendText}
					getValue={setRuleSendText}
					useBtnInput
					typeInput="number"
					textUseBtnInput="Salvar"
					placeHolder="Ex: 10"
					messageQuestionBox="Campo só permite número"
					functionUseBtnInput={() =>
						handleSaveGeneralConfig(ruleSendText, 'free_shipping_value')
					}
				/>
				<SimpleInput
					label={t('settings.featureSettings.discountCupon')}
					initialValue={discountCupon}
					getValue={setDiscountCupon}
					useBtnInput
					textUseBtnInput="Salvar"
					functionUseBtnInput={() =>
						handleSaveGeneralConfig(discountCupon, 'discount_coupon')
					}
				/>
			</S.threeItensPorLine>

			{listOptionsSelect.length > 0 ? (
				<S.threeItensPorLine>
					{listInputs.map((item) => (
						<S.labelWithOptions key={item.id}>
							<h3>{returnLabelBySlug(item.slug)}</h3>
							<S.boxOptions>
								{listOptionsSelect.map((optionToSelect) => (
									<S.optionToChose
										key={optionToSelect.id}
										$isSelect={item.affiliate_id === optionToSelect.id}
										onClick={() => {
											handleSave(item, optionToSelect.id);
										}}
									>
										<p>{optionToSelect.option}</p>
										{item.affiliate_id === optionToSelect.id && (
											<S.checkedItem data-testid="check-box">
												<FaCheck />
											</S.checkedItem>
										)}
									</S.optionToChose>
								))}
							</S.boxOptions>
						</S.labelWithOptions>
					))}
				</S.threeItensPorLine>
			) : (
				<S.noInputs>
					<p>Não a features</p>
				</S.noInputs>
			)}

			{/* <S.threeItensPorLine>
				<SelectInput
					label={t('settings.featureSettings.searchText')}
					list={listOptionsSelect}
					initialValue={
						dataForm.searchText.option === '' ? '' : dataForm.searchText
					}
					getValue={(value: SelectInputItemProps) => {
						setDataForm((obj) => ({ ...obj, searchText: value }));
					}}
				/>

				<SelectInput
					label={t('settings.featureSettings.searchByImg')}
					list={listOptionsSelect}
					initialValue={
						dataForm.searchByImg.option === '' ? '' : dataForm.searchByImg
					}
					getValue={(value: SelectInputItemProps) => {
						setDataForm((obj) => ({ ...obj, searchByImg: value }));
					}}
				/>

				<SelectInput
					label={t('settings.featureSettings.autocompleteSearch')}
					list={listOptionsSelect}
					initialValue={
						dataForm.autocompleteSearch.option === ''
							? ''
							: dataForm.autocompleteSearch
					}
					getValue={(value: SelectInputItemProps) => {
						setDataForm((obj) => ({
							...obj,
							autocompleteSearch: value
						}));
					}}
				/>

				<SelectInput
					label={t('settings.featureSettings.showcaseSawToo')}
					list={listOptionsSelect}
					initialValue={
						dataForm.showcaseSawToo.option === '' ? '' : dataForm.showcaseSawToo
					}
					getValue={(value: SelectInputItemProps) => {
						setDataForm((obj) => ({ ...obj, showcaseSawToo: value }));
					}}
				/>

				<SelectInput
					label={t('settings.featureSettings.searchByFilter')}
					list={listOptionsSelect}
					initialValue={
						dataForm.searcByFilters.option === '' ? '' : dataForm.searcByFilters
					}
					getValue={(value: SelectInputItemProps) => {
						setDataForm((obj) => ({ ...obj, searcByFilters: value }));
					}}
				/>

				<SelectInput
					label={t('settings.featureSettings.showCaseAlsoPurchased')}
					list={listOptionsSelect}
					initialValue={
						dataForm.showcaseAlsoPurchased.option === ''
							? ''
							: dataForm.showcaseAlsoPurchased
					}
					getValue={(value: SelectInputItemProps) => {
						setDataForm((obj) => ({
							...obj,
							showcaseAlsoPurchased: value
						}));
					}}
				/>

				<SelectInput
					label={t('settings.featureSettings.showCaseBoughtToo')}
					list={listOptionsSelect}
					initialValue={
						dataForm.showcaseBoughtToo.option === ''
							? ''
							: dataForm.showcaseBoughtToo
					}
					getValue={(value: SelectInputItemProps) => {
						setDataForm((obj) => ({
							...obj,
							showcaseBoughtToo: value
						}));
					}}
				/>

				<SelectInput
					label={t('settings.featureSettings.showcaseSearchShowTogether')}
					list={listOptionsSelect}
					initialValue={
						dataForm.showcaseSearchShowTogether.option === ''
							? ''
							: dataForm.showcaseSearchShowTogether
					}
					getValue={(value: SelectInputItemProps) => {
						setDataForm((obj) => ({
							...obj,
							showcaseSearchShowTogether: value
						}));
					}}
				/>

				<SelectInput
					label={t('settings.featureSettings.similarShowcase')}
					list={listOptionsSelect}
					initialValue={
						dataForm.similarShowcase.option === ''
							? ''
							: dataForm.similarShowcase
					}
					getValue={(value: SelectInputItemProps) => {
						setDataForm((obj) => ({
							...obj,
							similarShowcase: value
						}));
					}}
				/>

				<SelectInput
					label={t('settings.featureSettings.searchShowcaseAccessorie')}
					list={listOptionsSelect}
					initialValue={
						dataForm.searchShowcaseAccessorie.option === ''
							? ''
							: dataForm.searchShowcaseAccessorie
					}
					getValue={(value: SelectInputItemProps) => {
						setDataForm((obj) => ({
							...obj,
							searchShowcaseAccessorie: value
						}));
					}}
				/>

				<SelectInput
					label={t('settings.featureSettings.suggestionsShowcase')}
					list={listOptionsSelect}
					initialValue={
						dataForm.suggestionsShowcase.option === ''
							? ''
							: dataForm.suggestionsShowcase
					}
					getValue={(value: SelectInputItemProps) => {
						setDataForm((obj) => ({
							...obj,
							suggestionsShowcase: value
						}));
					}}
				/>

				<SelectInput
					label={t('settings.featureSettings.recommendationDisplay')}
					list={listOptionsSelect}
					initialValue={
						dataForm.recommendationDisplay.option === ''
							? ''
							: dataForm.recommendationDisplay
					}
					getValue={(value: SelectInputItemProps) => {
						setDataForm((obj) => ({
							...obj,
							recommendationDisplay: value
						}));
					}}
				/>
			</S.threeItensPorLine> */}
		</S.container>
	);
}
